import {
  inferOnboardingStageFromPath,
  type OnboardingStage,
} from "./marcusOnboardingFlow";

export const ONBOARDING_STAGE_LABELS: Record<OnboardingStage, string> = {
  explore: "Exploring Features",
  image_ads: "Static Ads",
  video_ads: "Video Ads",
  meta_campaigns: "Meta & Google Ads",
  agents_list: "Agent List",
  static_adclone: "Quick Static Ad Clone",
};

const ONBOARDING_STAGE_SEQUENCE: OnboardingStage[] = [
  "explore",
  "image_ads",
  "video_ads",
  "meta_campaigns",
  "agents_list",
  "static_adclone",
];

const ONBOARDING_NEXT_STEP_LABELS: Record<OnboardingStage, string> = {
  explore: "Static Ads",
  image_ads: "Video Ads",
  video_ads: "Meta & Google Ads",
  meta_campaigns: "Agent List",
  agents_list: "Quick Static Ad Clone",
  static_adclone: "Finish tour",
};

export function getOnboardingNextStep(activeStage: OnboardingStage | null) {
  if (!activeStage) return null;
  const activeIndex = ONBOARDING_STAGE_SEQUENCE.indexOf(activeStage);
  if (activeIndex === -1) return null;
  const completedSteps = activeIndex + 1;
  return {
    label: ONBOARDING_NEXT_STEP_LABELS[activeStage],
    completedSteps,
    remainingSteps: Math.max(ONBOARDING_STAGE_SEQUENCE.length - completedSteps, 0),
  };
}

export function getGateStage(activeStage: OnboardingStage | null, pathname: string) {
  if (activeStage === "agents_list" || activeStage === "static_adclone") return activeStage;
  return inferOnboardingStageFromPath(pathname) ?? activeStage;
}
